import {
    Booking,
    DetailsState,
    GoDreamGiftCard,
    IBookingDiscountOptions,
    IDiscountOptions,
    IGetPaymentInfo,
    IProductDetailsBooking,
    IProductDetailsKlippeCard,
    IReepayCustomerRaw,
    Package,
    ThirdPartyGiftCard,
} from '@raskrask-dk/bookingflow-state-machine'
import { GetData } from '@raskrask-dk/bookingflow-state-machine/lib/bookingflowstatemachine/bookingflowstatemachine.types'

export const adaptorToGetPaymentInfoOnDetailsState = (
    data: GetData<DetailsState>,
    disregardDiscountOptions: boolean
): IGetPaymentInfo => {
    const productDetails = constructProductDetails(data)
    const customer = constructReepayCustomer(data)
    const discountOptions = constructDiscountOptions(
        data,
        disregardDiscountOptions
    )
    return {
        productDetails: productDetails,
        productType: data.product.type,
        customer: customer,
        discountOptions: discountOptions,
    }
}

const constructProductDetails = (
    data: GetData<DetailsState>
): IProductDetailsBooking | IProductDetailsKlippeCard => {
    if (data.product.type === 'Booking') {
        const booking = data.product as Booking
        return {
            partner: {
                alias: booking.partner.alias,
                profileId: booking.partner.id,
            },
            serviceDate: booking.serviceDate.toString('yyyy-MM-dd HH:mm:ss'),
            serviceType: {
                duration: booking.service.duration.toMillis() / 60 / 1000,
                serviceTypeName: booking.service.name,
                serviceType_ID: booking.service.id,
            },
        } as IProductDetailsBooking
    }
    if (data.product.type === 'Package') {
        const pPackage = data.product as Package
        return {
            packageId: pPackage.id,
            partner: {
                alias: pPackage.partner.alias,
                profileId: pPackage.partner.id,
            },
            serviceType: {
                duration: pPackage.service.duration.toMillis() / 60 / 1000,
                serviceTypeName: pPackage.service.name,
                serviceType_ID: pPackage.service.id,
            },
        } as IProductDetailsKlippeCard
    } else {
        throw new Error()
    }
}

const constructReepayCustomer = (
    data: GetData<DetailsState>
): IReepayCustomerRaw | undefined => {
    if (data.customerEmail && data.customerName && data.customerPhone) {
        return {
            email: data.customerEmail,
            firstName: data.customerName.split(' ').slice(0, -1).join(' '),
            lastName: data.customerName.split(' ').slice(-1).join(' '),
            phone: data.customerPhone.toString(),
            customerType: 'Private',
        } as IReepayCustomerRaw
    }
    if (
        data.customerEmail &&
        data.companyAdminName &&
        data.companyName &&
        data.customerPhone
    ) {
        return {
            email: data.customerEmail,
            firstName: data.companyAdminName.split(' ').slice(0, -1).join(' '),
            lastName: data.companyAdminName.split(' ').slice(-1).join(' '),
            phone: data.customerPhone.toString(),
            customerType: 'Company',
        } as IReepayCustomerRaw
    }
    return undefined
}

const constructDiscountOptions = (
    data: GetData<DetailsState>,
    disregardDiscountOptions: boolean
): IDiscountOptions | undefined => {
    const productType = data.product.type
    if (disregardDiscountOptions) return undefined
    if (productType == 'Booking') {
        return {
            ...(data.promoCode && { promoCode: data.promoCode }),
            ...(data.klippeCardCode && { code: data.klippeCardCode }),

            ...(data.giftCard &&
                data.giftCard.giftCardProvider == 'RaskRask' && {
                    code: data.giftCard.code,
                }),

            ...(data.giftCard &&
                data.giftCard.giftCardProvider !== 'RaskRask' &&
                (data.giftCard as ThirdPartyGiftCard).providerId ==
                    undefined && { code: '' }),

            ...(data.giftCard &&
                data.giftCard.giftCardProvider !== 'RaskRask' &&
                (data.giftCard as ThirdPartyGiftCard).providerId && {
                    code: data.giftCard.code,
                    partnerGiftCardId: parseInt(
                        ((data.giftCard as ThirdPartyGiftCard)
                            .providerId as any) || 0
                    ),
                }),

            ...(data.giftCard &&
                (data.giftCard as GoDreamGiftCard).activationCode &&
                data.giftCard.giftCardProvider == 'GoDream' && {
                    code: `${data.giftCard.code} ${
                        (data.giftCard as GoDreamGiftCard).activationCode
                    }`,
                }),
        } as IBookingDiscountOptions
    }
    if (productType == 'Package') {
        return undefined
    }
    return undefined
}
